import React from "react";
import { Icon } from "../";
import { useGlobalUtils } from "@finitless/shared/lib";

const OverviewTab = ({ user }) => {
  const { parseDate } = useGlobalUtils();

  const name =
    user?.name && user?.lastname
      ? `${user.name} ${user.lastname}`
      : user?.name || "Unknown";

  const phone =
    user?.country_phone_code && user?.cellphone
      ? `+${user.country_phone_code} ${user.cellphone}`
      : user?.cellphone || "N/A";

  const email = user?.email || "N/A";

  return (
    <div className="space-y-6">
      {/* User Info */}
      <div className="border-border bg-card rounded-md border p-6">
        <h3 className="text-foreground mb-4 flex items-center text-lg font-semibold">
          <Icon name="User" className="mr-2 h-5 w-5" />
          Driver Manager Info
        </h3>
        <div className="space-y-3">
          <div className="grid grid-cols-1 gap-1 sm:grid-cols-[auto_minmax(0,1fr)] sm:gap-x-4">
            <span className="text-muted-foreground whitespace-nowrap">
              Name:
            </span>
            <span className="text-foreground min-w-0 break-words sm:text-end">
              {name}
            </span>
          </div>
          <div className="grid grid-cols-1 gap-1 sm:grid-cols-[auto_minmax(0,1fr)] sm:gap-x-4">
            <span className="text-muted-foreground whitespace-nowrap">
              Phone:
            </span>
            <span className="text-foreground min-w-0 break-words sm:text-end">
              {phone}
            </span>
          </div>
          <div className="grid grid-cols-1 gap-1 sm:grid-cols-[auto_minmax(0,1fr)] sm:gap-x-4">
            <span className="text-muted-foreground whitespace-nowrap">
              Email:
            </span>
            <span className="text-foreground min-w-0 break-words sm:text-end">
              {email}
            </span>
          </div>
          <div className="grid grid-cols-1 gap-1 sm:grid-cols-[auto_minmax(0,1fr)] sm:gap-x-4">
            <span className="text-muted-foreground whitespace-nowrap">
              Status:
            </span>
            <span
              className={`justify-self-start rounded-full px-2 py-1 text-xs font-medium sm:justify-self-end ${
                user?.enabled
                  ? "border-success text-success border bg-[var(--success-bg)]"
                  : "border-error text-error border bg-[var(--error-bg)]"
              }`}
            >
              {user?.enabled ? "Active" : "Inactive"}
            </span>
          </div>
          <div className="grid grid-cols-1 gap-1 sm:grid-cols-[auto_minmax(0,1fr)] sm:gap-x-4">
            <span className="text-muted-foreground whitespace-nowrap">
              Joined:
            </span>
            <span className="text-foreground min-w-0 break-words sm:text-end">
              {parseDate(user?.created_at)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewTab;
